// 개인정보 수집 & 이용 및 제3자 제공 동의
const MarketingConsent = `제1부 — [필수] 개인정보 수집·이용 동의

주식회사 퍼니즈(이하 "회사")는 Castar 서비스(웹·앱 포함, 이하 "서비스") 제공을 위해 필요한 최소한의 개인정보를 아래와 같이 수집·이용합니다. 본 동의는 서비스 제공을 위해 필수적이며, 동의하지 않을 경우 Castar 서비스 이용이 제한됩니다.

제1조 (개인정보 수집 목적)

회사는 다음 각 호의 목적을 위해 이용자의 개인정보를 수집·이용합니다.

1. 회원 가입 및 본인 확인
  - 본인 식별, 아이디·비밀번호 관리
  - 휴대전화번호 인증, 연령 확인

2. Castar 주요 서비스 제공
  - 배우 프로필 및 포트폴리오 생성·관리
  - 제작사에게 배우 프로필 제공 및 매칭·연락
  - 오디션 공고 열람, 지원, 합격 통지 등 캐스팅 과정 전체 지원

3. 유료 서비스 제공 및 결제 관리
  - 정기구독 및 유료 서비스 결제, 환불, 정산
  - 구매 내역 확인 및 이용자 보호

4. 고객지원 및 서비스 운영
  - 민원 처리, 문의 응대, 서비스 공지 및 운영 관련 알림
  - 회원관리, 계정 도용 방지, 부정 이용 탐지

5. 서비스 품질 개선
  - 서비스 이용 통계 분석
  - 기능 개선 및 신규 서비스 개발
  - 서비스 안정화 및 오류 분석

6. 법령 준수
  - 관계 법령, 감독기관 요구 대응
  - 분쟁 해결 및 소비자보호 관련 법령 준수

※ 회사는 위 목적 외의 용도로 이용하지 않으며, 목적이 변경될 경우 관련 법령에 따라 별도 동의를 받습니다.

제2조 (수집 항목)

회사는 서비스 제공을 위하여 아래의 항목을 수집합니다.

1. 회원가입 시 수집되는 정보
  - 이름, 생년월일, 성별
  - 이메일 주소(ID 포함), 비밀번호
  - 휴대전화번호
  - 예명

2. 배우 포트폴리오·프로필 등록 시 수집 정보
  - 프로필 사진(안면·반신·전신)
  - 자기소개 영상, 연기 영상 등
  - 신체 정보(키, 체중 등 최소한의 캐스팅 목적 범위)
  - 경력, 필모그래피, 학력, 수상 이력
  - 희망 분야, 특기, 언어 능력 등 이용자가 입력한 추가 정보

3. 제작사·기업 회원 정보
  - 담당자명, 직책
  - 연락처(휴대전화번호, 이메일)
  - 회사명, 사업자등록번호, 주소, 홈페이지 등

4. 서비스 이용 중 자동으로 생성·수집되는 정보
  - 서비스 이용 기록, 검색 기록, 오디션 지원 기록
  - 접속 로그(IP 포함), 기기 정보(운영체제, 브라우저 정보 등)
  - 쿠키(cookie), 광고식별자, 접속 이력
  - 오류 로그 및 부정 이용 기록

5. 유료 결제 시 수집되는 정보
  - 결제 승인번호, 결제 금액, 카드사 정보 등 결제에 필요한 정보
  - 정산이 필요한 경우: 은행명, 계좌번호, 예금주명

6. 고객센터 이용 시 수집 정보
  - 문의 유형, 문의 내용, 이메일 주소, 전화번호
  - 첨부 파일(필요 시)

※ 회사는 민감정보(사상, 신념, 건강, 생체정보 등)는 원칙적으로 수집하지 않으며, 필요한 경우에는 법령에 따라 별도 동의를 받습니다.

제3조 (개인정보 수집 방법)

회사는 다음과 같은 방법으로 개인정보를 수집합니다.

1. 회원가입 및 서비스 이용 과정에서 이용자가 직접 입력한 정보
2. 배우 포트폴리오 업로드, 오디션 지원 등 서비스 기능 이용 과정에서 자발적으로 제공되는 정보
3. 고객센터 문의, 이메일, 설문조사, 이벤트 응모 등을 통해 제공되는 정보
4. 서비스 이용 과정에서 자동으로 생성되는 정보(로그 파일, 쿠키 등)

제4조 (개인정보의 보유·이용 기간)

회사는 개인정보를 원칙적으로 수집·이용 목적 달성 시까지 보유·이용하며, 목적 달성 후 즉시 파기합니다.

다만, 관련 법령에 따라 다음의 정보는 정해진 기간 동안 보관할 수 있습니다.

1. 계약 또는 청약철회 등에 관한 기록 — 5년
2. 대금 결제 및 재화·서비스 공급에 관한 기록 — 5년
3. 소비자 불만 또는 분쟁 처리에 관한 기록 — 3년
4. 표시·광고에 관한 기록 — 6개월
5. 접속기록(IP 포함) — 3개월

또한, 부정 이용 방지를 위해 다음 정보를 회원 탈퇴 후 최대 1년간 보관할 수 있습니다.
  - 본인인증값, ID, 탈퇴 기록, 부정 이용 관련 기록 등

※ 법령에서 별도의 보관 기간을 정한 경우에는 그에 따릅니다.

제5조 (개인정보 수집·이용 동의 거부권 및 불이익)

1. 이용자는 개인정보의 수집·이용에 대한 동의를 거부할 수 있습니다.
2. 다만, 본 동의는 서비스 제공을 위해 필수적이므로 동의를 거부할 경우 Castar 서비스 이용이 불가능합니다.

제6조 (동의 문구)

"본인은 주식회사 퍼니즈의 '개인정보 수집·이용' 내용에 대해 충분히 확인하였으며, 이에 동의합니다."


제2부 — [필수] 개인정보 제3자 제공 동의 (제작사 제공)

주식회사 퍼니즈(이하 "회사")는 Castar 서비스의 본질적 기능인 배우–제작사 간 매칭 및 캐스팅 진행을 위하여 이용자의 개인정보를 아래와 같이 제3자에게 제공합니다.

본 제공은 Castar 서비스의 필수 기능 수행에 반드시 필요한 사항으로, 동의를 거부하는 경우 Castar의 핵심 서비스(오디션 지원 및 매칭) 이용이 불가능합니다.

제1조 (제공받는 자)

다음의 배우 캐스팅 관련 제3자를 의미합니다.

1. 영상·영화·OTT·광고·웹드라마·SNS 콘텐츠 등
  - 콘텐츠 제작사, 영화사, 프로덕션, 미디어 제작사

2. 방송·영상·광고 제작을 담당하는
  - PD, 감독, 연출자, 캐스팅 디렉터, 제작팀, 캐스팅 담당자

3. Castar 플랫폼에 오디션·캐스팅 공고를 등록한
  - 기업·단체·개인 제작자

※ 위 제3자의 구체적 명칭은 공고 게시 및 매칭 과정에서 이용자에게 개별적으로 확인됩니다.

제2조 (제공 목적)

제공된 개인정보는 아래 목적에 한하여 이용됩니다.

1. 배우 포트폴리오 검토 및 배역 적합성 판단
2. 오디션 제안, 면접·미팅 조율, 촬영 일정 협의
3. 출연 계약 진행 및 계약 조건 협의
4. 작품 참여 여부 판단 및 캐스팅 확정
5. 오디션·촬영 등 제작 업무 운영 및 커뮤니케이션

※ 회사는 개인정보를 위 목적 외 다른 용도로 제공하지 않습니다.

제3조 (제공 항목)

배우 캐스팅을 위해 필요한 최소한의 개인정보만 제공됩니다.

1. 기본 정보
  - 이름, 성별, 생년월일 또는 연령대
  - 연락처(휴대전화번호), 이메일 주소

2. 배우 포트폴리오·프로필 정보
  - 프로필 사진(안면, 반신, 전신)
  - 영상(자기소개 영상, 연기 영상 등 이용자가 업로드한 파일)
  - 신체 정보(키, 몸무게 등 캐스팅 목적 범위)
  - 경력, 학력, 필모그래피, 자기소개 등
  - 특기, 언어능력, 활동 가능 지역 등 이용자가 입력한 기타 항목

3. Castar 서비스 이용 정보
  - 오디션 지원 이력
  - 포트폴리오 업데이트 정보
  - 매칭·대기 상태 정보 등 캐스팅 진행에 필요한 사항

제4조 (보유 및 이용 기간)

1. 제작사는 해당 오디션·캐스팅 공고의 진행 및 종료 시점까지 이용자의 개인정보를 보유·이용합니다.
2. 공고가 종료되거나 캐스팅 절차가 완료된 이후에는 제작사 내부 규정에 따라 계약, 회계 처리, 분쟁 대응 등 법령상 필요 범위 내에서만 보관할 수 있습니다.
3. 회사는 제3자 제공 내역을 관리하며, 이용자가 열람·요청 시 관련 기록을 제공합니다.

제5조 (동의 거부권 및 불이익 안내)

1. 이용자는 개인정보 제3자 제공에 대해 동의를 거부할 수 있습니다.
2. 단, 본 제공은 Castar 서비스의 필수 기능(배우–제작사 매칭, 오디션 지원)에 반드시 필요하므로 동의하지 않을 경우 Castar 서비스 이용이 제한되며, 특히 오디션 지원 및 배우 포트폴리오 제공 기능을 사용할 수 없습니다.

제6조 (동의 문구)

"본인은 주식회사 퍼니즈가 Castar 서비스 제공을 위하여 위와 같은 범위 내에서 개인정보를 제3자(제작사·캐스팅 담당자)에게 제공하는 것에 동의합니다."`;

export default MarketingConsent;
